// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_lodash_isEmpty_js-node_modules_lodash_isEqual_js":"c4d93c054a0a13445bd2","src_pages_help_index_tsx":"6b8f4f0c4039e63da68c","src_pages_ticket-accept_index_tsx":"571e547d93ecbbeda0ce"}[chunkId] + ".js";
};